// SPDX-License-Identifier: AGPL-3.0-or-later

export interface PrivyWalletCandidate {
	address: string;
	walletClientType: string;
	imported?: boolean;
	userCanSign?: boolean;
	linked?: boolean;
}
export function isPrivyWalletClient(value: unknown): boolean {
	return value === 'privy' || value === 'privy-v2';
}
export function ownEmbeddedWallets<T extends PrivyWalletCandidate>(wallets: ReadonlyArray<T>): Array<T> {
	return wallets.filter(
		(wallet) => isPrivyWalletClient(wallet.walletClientType) && wallet.userCanSign !== false && wallet.linked !== false,
	);
}
export function findBusinessWallet<T extends PrivyWalletCandidate>(
	wallets: ReadonlyArray<T>,
	address: string | null,
): T | null {
	if (!address) return null;
	return ownEmbeddedWallets(wallets).find((wallet) => wallet.address.toLowerCase() === address.toLowerCase()) ?? null;
}
// A selected address is immutable after backend confirmation; never fall back to wallets[0].
export function recoverableWallet<T extends PrivyWalletCandidate>(
	wallets: ReadonlyArray<T>,
	address: string | null,
): T | null {
	const embedded = ownEmbeddedWallets(wallets);
	return address ? findBusinessWallet(embedded, address) : embedded.length === 1 ? embedded[0] : null;
}
